import React, { useState } from 'react';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { GetAntrepoByIdResponseAntrepoArea, GetAntrepoByIdResponseAntrepoShelf } from '../../../../models/response/antrepo/GetAntrepoByIdResponse';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import { toast } from "react-hot-toast";
import { Helpers } from '../../../../helpers/Helpers';
import { ConstantService } from '../../../../services/ConstantService';
import Box from '../../../../components/Box';
import CustomSwitch from '../../../../components/CustomSwitch';
import { storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';
import { useDispatch } from 'react-redux';

interface Props {
    shelfRef: any
    antrepoShelfs: GetAntrepoByIdResponseAntrepoShelf[]
    setAntrepoShelfs: React.Dispatch<React.SetStateAction<GetAntrepoByIdResponseAntrepoShelf[]>>
}

const ShelfInformation = ({
    shelfRef,
    antrepoShelfs,
    setAntrepoShelfs
}: Props) => {
    const dispatch = useDispatch();
    const [antrepoShelfId, setAntrepoShelfId] = useState<string | undefined>(undefined);
    const [isOpen, setIsOpen] = useState(false);
    const [_, setAddress] = useState<string | undefined>(undefined);
    const [selectedAntrepoShelfType, setSelectedAntrepoShelfType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [corridor, setCorridor] = useState<string | undefined>(undefined);
    const [column, setColumn] = useState<string | undefined>(undefined);
    const [floor, setFloor] = useState<string | undefined>(undefined);
    const [level, setLevel] = useState<string | undefined>(undefined);
    const [isWizardOpen, setIsWizardOpen] = useState(false);

    const [corridor1, setCorridor1] = useState<string | undefined>(undefined);
    const [corridor2, setCorridor2] = useState<string | undefined>(undefined);

    const [column1, setColumn1] = useState<number | undefined>(undefined);
    const [column2, setColumn2] = useState<number | undefined>(undefined);

    const [floor1, setFloor1] = useState<number | undefined>(undefined);
    const [floor2, setFloor2] = useState<number | undefined>(undefined);

    const [level1, setLevel1] = useState<number | undefined>(undefined);
    const [level2, setLevel2] = useState<number | undefined>(undefined);

    const [isCustomActive, setIsCustomActive] = useState<boolean | undefined>(true);

    const setUpdateItem = () => {
        var o = antrepoShelfs.filter(x => x.isSelected)[0];

        setAntrepoShelfId(o.antrepoShelfId);
        setAddress(o.address);
        setSelectedAntrepoShelfType(o.antrepoShelfTypeId && o.antrepoShelfTypeName ? { label: o.antrepoShelfTypeName, value: o.antrepoShelfTypeId } : undefined);
        setCorridor(o.corridor);
        setColumn(o.column);
        setFloor(o.floor);
        setLevel(o.level);
        setIsCustomActive(o.isCustomActive);
        setIsOpen(true);
        scrollTo();
    }

    const cancelAdding = () => {
        setIsWizardOpen(false);

        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setAntrepoShelfId('');
        setAddress('');
        setSelectedAntrepoShelfType(undefined);
        setCorridor('');
        setColumn('');
        setFloor('');
        setLevel('');
        setIsCustomActive(true);
        setIsOpen(false);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = shelfRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const deleteItems = () => {
        setAntrepoShelfs(antrepoShelfs.filter(x => !x.isSelected));
    }

    const selectAll = () => {
        var isAllSelected = antrepoShelfs.length == antrepoShelfs.filter(x => x.isSelected).length;

        setAntrepoShelfs(antrepoShelfs.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const setItemSelected = (_id: string) => {
        setAntrepoShelfs(antrepoShelfs.map(function (x) {
            if (x.antrepoShelfId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const saveWizard = () => {
        if (!corridor1 || !corridor2 || Helpers.isEmpty(corridor1) || Helpers.isEmpty(corridor2)) {
            toast.error('Koridor alanını doldurunuz!')
        }
        else if (!column1 || !column2 || Helpers.isEmpty(column1) || Helpers.isEmpty(column2)) {
            toast.error('Sütun alanını doldurunuz!')
        }
        else if (!floor1 || !floor2 || Helpers.isEmpty(floor1) || Helpers.isEmpty(floor2)) {
            toast.error('Kat alanını doldurunuz!')
        }
        else if (!level1 || !level2 || Helpers.isEmpty(level1) || Helpers.isEmpty(level2)) {
            toast.error('Hücre / Seviye alanını doldurunuz!')
        }
        else {
            var newList: GetAntrepoByIdResponseAntrepoShelf[] = [];

            for (var i1 = corridor1.charCodeAt(0); i1 <= corridor2.charCodeAt(0); i1++) {
                var _corridor = String.fromCharCode(i1);

                for (var i2 = column1; i2 <= column2; i2++) {
                    var _column = i2;

                    for (var i3 = floor1; i3 <= floor2; i3++) {
                        var _floor = i3;

                        for (var i4 = level1; i4 <= level2; i4++) {
                            var _level = i4;

                            var o: GetAntrepoByIdResponseAntrepoShelf = {
                                antrepoShelfId: Helpers.generateUUID(),
                                isSelected: false,
                                address: [_corridor, _column, _floor, _level].filter(x => x && !Helpers.isEmpty(x)).join('-'),
                                antrepoShelfTypeId: selectedAntrepoShelfType?.value,
                                antrepoShelfTypeName: selectedAntrepoShelfType?.label,
                                column: _column.toString(),
                                corridor: _corridor,
                                floor: _floor.toString(),
                                isCustomActive: true,
                                level: _level.toString()
                            }

                            newList.push(o);
                        }
                    }
                }
            }

            setAntrepoShelfs([...antrepoShelfs, ...newList])
            setIsWizardOpen(false);
            setCorridor1('');
            setCorridor2('');
            setColumn1(0);
            setColumn2(0);
            setFloor1(0);
            setFloor2(0);
            setLevel1(0);
            setLevel2(0);
            setSelectedAntrepoShelfType(undefined);
            scrollTo();
        }
    }

    const saveItem = () => {
        // if (Helpers.isEmpty(name))
        //     toast.error('Alan Adı alanını doldurunuz!')
        // else if (!selectedAntrepoShelfType)
        //     toast.error('Alan Türü alanını doldurunuz!')
        // else {
        if (Helpers.isEmpty(antrepoShelfId)) {
            var o: GetAntrepoByIdResponseAntrepoShelf = {
                antrepoShelfId: Helpers.generateUUID(),
                isSelected: false,
                address: [corridor, column, floor, level].filter(x => x && !Helpers.isEmpty(x)).join('-'),
                antrepoShelfTypeId: selectedAntrepoShelfType?.value,
                antrepoShelfTypeName: selectedAntrepoShelfType?.label,
                column: column,
                corridor: corridor,
                floor: floor,
                isCustomActive: isCustomActive,
                level: level
            }

            setAntrepoShelfs([...antrepoShelfs, o])
        }
        else {
            setAntrepoShelfs(antrepoShelfs.map(function (x) {
                if (x.antrepoShelfId == antrepoShelfId) {
                    x.address = [corridor, column, floor, level].filter(x => x && !Helpers.isEmpty(x)).join('-');
                    x.antrepoShelfTypeId = selectedAntrepoShelfType?.value;
                    x.antrepoShelfTypeName = selectedAntrepoShelfType?.label;
                    x.column = column;
                    x.corridor = corridor;
                    x.floor = floor;
                    x.isCustomActive = isCustomActive;
                    x.level = level
                }

                return x;
            }))
        }

        setAntrepoShelfId('');
        setAddress('');
        setSelectedAntrepoShelfType(undefined);
        setCorridor('');
        setColumn('');
        setFloor('');
        setLevel('');
        setIsCustomActive(true);
        setIsOpen(false);
        scrollTo();
        // }
    }

    return (
        <div className='containerPart' ref={shelfRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Antrepo Raf Bilgileri</h4>

                    {
                        isWizardOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Koridor</label>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <input style={{ border: '1px solid #F1F1F4' }} value={corridor1} onChange={(e) => setCorridor1(e.target.value)} type="text" className="form-control form-control-solid" />
                                            </div>
                                            <div className="col-md-6">
                                                <input style={{ border: '1px solid #F1F1F4' }} value={corridor2} onChange={(e) => setCorridor2(e.target.value)} type="text" className="form-control form-control-solid" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Raf Tipi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedAntrepoShelfType}
                                            onChange={setSelectedAntrepoShelfType}
                                            onMenuOpen={() => ConstantService.getConstantList('ANTREPO_SHELF_TYPE', undefined, undefined)}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Sütun</label>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <input style={{ border: '1px solid #F1F1F4' }} value={column1} onChange={(e) => setColumn1(parseInt(e.target.value))} type="number" className="form-control form-control-solid" />
                                            </div>
                                            <div className="col-md-6">
                                                <input style={{ border: '1px solid #F1F1F4' }} value={column2} onChange={(e) => setColumn2(parseInt(e.target.value))} type="number" className="form-control form-control-solid" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Kat</label>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <input style={{ border: '1px solid #F1F1F4' }} value={floor1} onChange={(e) => setFloor1(parseInt(e.target.value))} type="number" className="form-control form-control-solid" />
                                            </div>
                                            <div className="col-md-6">
                                                <input style={{ border: '1px solid #F1F1F4' }} value={floor2} onChange={(e) => setFloor2(parseInt(e.target.value))} type="number" className="form-control form-control-solid" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Hücre / Seviye</label>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <input style={{ border: '1px solid #F1F1F4' }} value={level1} onChange={(e) => setLevel1(parseInt(e.target.value))} type="number" className="form-control form-control-solid" />
                                            </div>
                                            <div className="col-md-6">
                                                <input style={{ border: '1px solid #F1F1F4' }} value={level2} onChange={(e) => setLevel2(parseInt(e.target.value))} type="number" className="form-control form-control-solid" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveWizard} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Adres</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={[corridor, column, floor, level].filter(x => !Helpers.isEmpty(x)).join('-')} onChange={(e) => setAddress(e.target.value)} type="text" className="form-control form-control-solid" disabled />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Raf Tipi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedAntrepoShelfType}
                                            onChange={setSelectedAntrepoShelfType}
                                            onMenuOpen={() => ConstantService.getConstantList('ANTREPO_SHELF_TYPE', undefined, undefined)}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>

                                <div className='row mt-5'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Koridor</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={corridor} onChange={(e) => setCorridor(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Sütun</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={column} onChange={(e) => setColumn(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Kat</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={floor} onChange={(e) => setFloor(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>
                                </div>

                                <div className='row mt-5'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Hücre / Seviye</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={level} onChange={(e) => setLevel(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>

                                        <CustomSwitch isActive={isCustomActive} setIsActive={setIsCustomActive} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={(isWizardOpen || isOpen) ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={antrepoShelfs.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={antrepoShelfs.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>

                        <Box onClick={antrepoShelfs.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={antrepoShelfs.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>

                        <Box onClick={antrepoShelfs.filter(x => x.isSelected).length > 0 ? () => alert('NOT IMPLEMENTED YET') : undefined} opacity={antrepoShelfs.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2" bg='orange' justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-barcode" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Barkod</span>
                            </Box>
                        </Box>

                        <Box onClick={() => { setIsOpen(false); setIsWizardOpen(!isWizardOpen); }} ml="10px" className="actionIcon p-2" bg='#8c8c8c' justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-barcode" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Raf Sihirbazını {isWizardOpen ? 'Gizle' : 'Göster'}</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={antrepoShelfs.filter(x => x.isSelected).length > 0 && antrepoShelfs.filter(x => x.isSelected).length == antrepoShelfs.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Adres</th>
                                            <th>Koridor</th>
                                            <th>Sütun</th>
                                            <th>Kat</th>
                                            <th>Hücre / Seviye</th>
                                            <th>Raf Tipi</th>
                                            <th>Aktif</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            antrepoShelfs.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            antrepoShelfs.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input onChange={() => setItemSelected(item.antrepoShelfId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.address}</td>
                                                    <td>{item.corridor}</td>
                                                    <td>{item.column}</td>
                                                    <td>{item.floor}</td>
                                                    <td>{item.level}</td>
                                                    <td>{item.antrepoShelfTypeName}</td>
                                                    <td>{item.isCustomActive ? <i style={{ fontSize: 20 }} className="text-success fa fa-check-circle" /> : <i style={{ fontSize: 20 }} className="text-danger fa fa-times-circle" />}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default ShelfInformation;